import React from 'react';
import type WhiteboardController from '../controllers/WhiteboardController';
import { type MenuItemDefinition } from '../stylus/definitions';
import StylusFlow from '../stylus/StylusFlow';
import styles from './businessProcess.module.css';
import {
  type BusinessProcessFlow,
  type BusinessProcessShape,
  type BusinessProcessShapeNames,
} from './definitions';
import { BusinessProcessIcon } from './icons';

export const makeBusinessProcessItem = (
  shape: BusinessProcessShape & { shapeName: BusinessProcessShapeNames }
): MenuItemDefinition => ({
  itemType: 'definition',
  description: () => shape.name,
  // eslint-disable-next-line react/display-name
  renderIcon: () => (
    <BusinessProcessIcon shapeName={shape.shapeName} variant={shape.variant} />
  ),
  stylusId: () => `${shape.shapeName}-${shape.variant}`,
  toolButtonClass: () => styles.businessProcessLargeButton,

  stylusDefinition: {
    objectType: 'shape',
    shapeName: shape.shapeName,
    options: { variant: shape.variant },
  },
  shapeName: shape.shapeName,
});

export const makeBusinessProcessFlowItem =
  (controller: WhiteboardController) =>
  (flow: BusinessProcessFlow): StylusFlow =>
    new StylusFlow({ controller, flowId: flow.id });
